import { render, staticRenderFns } from "./CertificationRequestDetail.vue?vue&type=template&id=3f39312b&"
import script from "./CertificationRequestDetail.vue?vue&type=script&lang=js&"
export * from "./CertificationRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports